
    import Checkmark from './Animations/Checkmark.vue';

    export default {
        data() {
            return {
                error_messages: null,
                modal_visible: false,
                // terms: false,
                personal_info: false,
                first_name: "",
                last_name: "",
                birth_date: "",
                birth_place: "",
                profession: "",
                education_level: "",
                work: "",
                email_address: "",
                telephone: "",
                can_register: false,
                registration_complete: false,
                main_error_message: "",
            };
        },
        props: ["education_id", "education_name", "education_author", "author_avatar"],
        created() { },
        mounted() {
            this.$watch("$data", this.observeForm, { deep: true });
        },
        methods: {
            show() {
                this.modal_visible = true;
                document.body.style.overflow = "hidden";
            },
            close() {
                this.modal_visible = false;
                this.resetForm();
                document.body.style.overflow = "auto";
            },
            observeForm() {
                if (
                // this.terms &&
                this.personal_info &&
                    (this.first_name.trim().length > 0) &&
                    (this.last_name.trim().length > 0) &&
                    (this.birth_date.trim().length > 0) &&
                    (this.birth_place.trim().length > 0) &&
                    (this.profession.trim().length > 0) &&
                    (this.education_level.trim().length > 0) &&
                    (this.work.trim().length > 0) &&
                    (this.email_address.trim().length > 0) &&
                    (this.telephone.trim().length > 0)) {
                    this.can_register = true;
                }
                else {
                    this.can_register = false;
                }
            },
            resetForm() {
                // this.terms = false;
                this.personal_info = false;
                this.first_name = "";
                this.last_name = "";
                this.birth_date = "";
                this.birth_place = "";
                this.profession = "";
                this.education_level = "";
                this.work = "";
                this.email_address = "";
                this.telephone = "";
                this.can_register = false;
                this.registration_complete = false;
                this.error_messages = null;
            },
            sendRegistration() {
                if (this.can_register) {
                    const student = {
                        first_name: this.first_name,
                        last_name: this.last_name,
                        birth_date: this.birth_date,
                        birth_place: this.birth_place,
                        profession: this.profession,
                        education_level: this.education_level,
                        work: this.work,
                        email_address: this.email_address,
                        telephone: this.telephone,
                        education_id: this.education_id
                    };
                    this.$axios.post("/education/register", student)
                        .then(response => {
                        if (response.status === 200) {
                            this.registration_complete = true;
                        }
                    })
                        .catch(error => {
                        if (error.response) {
                            if (error.response.status === 422) {
                                this.main_error_message = "Provjerite jesu li sva polja ispravno popunjena.";
                            }
                            if (error.response.status === 409) {
                                this.main_error_message = "Prijava sa ovom email adresom je već izvršena za ovu edukaciju.";
                            }
                            if (error.response.data) {
                                this.error_messages = error.response.data.errors;
                            }
                        }
                    });
                }
            }
        },
        components: { Checkmark }
    }
